import type { NotesWithType } from "@/components/features/matter/notes/matter-note-columns";
import type { Matter, MatterNote } from "@/lib/types";

const MATTER_NOTE_SUB_ITEM_KEY_MAP: Record<string, keyof MatterNote> = {
  matterVehicleId: "vehicleId",
  matterIncidentReportId: "incidentReportId",
  matterInsuranceId: "insuranceId",
  matterSettlementDemandId: "settlementDemandId",
  matterSettlementOfferId: "settlementOfferId",
  matterSettlementCounterId: "settlementCounterId",
  matterExpenseId: "expenseId",
  matterLostWagesId: "lostWagesId",
  matterLienId: "lienId",
  matterPropertyDamageId: "propertyDamageId",
  matterSignatureRequestId: "signatureRequestId",
  matterTrustCheckId: "trustCheckId",
  matterLitigationDateId: "litigationDateId",
  matterMedicalTreatmentPlanId: "medicalTreatmentPlanId",
  matterStatuteOfLimitationsId: "statuteOfLimitationsId",
  matterFileId: "fileId",
  matterEmailId: "emailId",
};

export const getMatterNoteSubItemKey = (itemKey: string) =>
  MATTER_NOTE_SUB_ITEM_KEY_MAP[itemKey] ?? (itemKey as keyof MatterNote);

export const formatNotesWithType = ({
  notes,
  matter,
}: {
  notes: MatterNote[];
  matter: Matter;
}) =>
  notes.map((note) => {
    let type = "Matter";
    let itemId = matter.matterId;
    if (note.vehicleId) {
      type = "Vehicle";
      itemId = note.vehicleId;
    }
    if (note.incidentReportId) {
      type = "Incident Report";
      itemId = note.incidentReportId;
    }
    if (note.insuranceId) {
      type = "Insurance";
      itemId = note.insuranceId;
    }
    if (note.medicalTreatmentId) {
      type = "Medical Treatment";
      itemId = note.medicalTreatmentId;
    }
    if (note.medicalTreatmentBillId) {
      type = "Medical Treatment Bill";
      itemId = note.medicalTreatmentBillId;
    }
    if (note.medicalTreatmentAppointmentId) {
      type = "Medical Treatment Appointment";
      itemId = note.medicalTreatmentAppointmentId;
    }
    if (note.medicalTreatmentRecordId) {
      type = "Medical Treatment Record";
      itemId = note.medicalTreatmentRecordId;
    }
    if (note.medicalTreatmentPlanId) {
      type = "Medical Treatment Plan";
      itemId = note.medicalTreatmentPlanId;
    }
    if (note.medicalTreatmentBalanceConfirmationId) {
      type = "Balance Confirmation";
      itemId = note.medicalTreatmentBalanceConfirmationId;
    }
    if (note.settlementDemandId) {
      type = "Demand";
      itemId = note.settlementDemandId;
    }
    if (note.settlementOfferId) {
      type = "Offer";
      itemId = note.settlementOfferId;
    }
    if (note.settlementCounterId) {
      type = "Counter";
      itemId = note.settlementCounterId;
    }
    if (note.expenseId) {
      type = "Cost";
      itemId = note.expenseId;
    }
    if (note.lostWagesId) {
      type = "Lost Wage";
      itemId = note.lostWagesId;
    }
    if (note.lienId) {
      type = "Lien";
      itemId = note.lienId;
    }
    if (note.propertyDamageId) {
      type = "Property Damage";
      itemId = note.propertyDamageId;
    }
    if (note.signatureRequestId) {
      type = "Signature Request";
      itemId = note.signatureRequestId;
    }
    if (note.trustCheckId) {
      type = "Trust Check";
      itemId = note.trustCheckId;
    }
    if (note.litigationDateId) {
      type = "Litigation Date";
      itemId = note.litigationDateId;
    }
    if (note.statuteOfLimitationsId) {
      type = "Statute of Limitations";
      itemId = note.statuteOfLimitationsId;
    }
    if (note.emailId) {
      type = "Email";
      itemId = note.emailId;
    }
    if (note.fileId) {
      type = "File";
      itemId = note.fileId;
    }
    return {
      ...note,
      type,
      itemId,
    };
  }) as NotesWithType[];
